export default __webpack_public_path__ + "static/media/icon_quocte.063c2d17.svg";